/* eslint-disable react/destructuring-assignment */
import styled from 'styled-components';

const PhoneScreenImage = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 1px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${props => props.screenImage}); 
  box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.5);
`;

export default PhoneScreenImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/PhoneScreenImage.jsx